import React, {Component} from 'react'
import { Modal } from 'semantic-ui-react'

import ConsequenceCell from '../consequence_cell';
import { getText } from '../../../helpers';

import '../consequence_table.css'

export default class FiveConsequencesTable extends Component {
  constructor(props){
    super(props);

    const { row, isNewConsequence, translations={} } = props;
    this.state = { 
      row,
      rowsCount: 5,
      notClickableColumns: []
    };

    const datafield_prefix = isNewConsequence ? "new_" : "";

    const { financial, safety, occ_health, reputation, environment, legal, community,
      financial1, financial2, financial3, financial4, financial5,
      safety1, safety2, safety3, safety4, safety5,
      occ_health1, occ_health2, occ_health3, occ_health4, occ_health5,
      reputation1, reputation2, reputation3, reputation4, reputation5,
      environment1, environment2, environment3, environment4, environment5,
      legal1, legal2, legal3, legal4, legal5,
      community1, community2, community3, community4, community5 } = translations

    this.consequences = [
      {
        dataField: datafield_prefix + "financial",
        text: financial,
        classes: "consequences-table-cell centered",
        headerClasses: "consequences-table-header",
        expandable: false,
        rows: [ financial1, financial2, financial3, financial4, financial5 ]
      },
      {
        dataField: datafield_prefix + "safety",
        text: safety,
        classes: "consequences-table-cell centered",
        headerClasses: "consequences-table-header",
        expandable: false,
        rows: [ safety1, safety2, safety3, safety4, safety5 ]
      },
      {
        dataField: datafield_prefix + "health",
        text: occ_health,
        classes: "consequences-table-cell centered",
        headerClasses: "consequences-table-header",
        expandable: true,
        rows: [ occ_health1, occ_health2, occ_health3, occ_health4, occ_health5 ]
      },
      {
        dataField: datafield_prefix + "reputation",
        text: reputation,
        classes: "consequences-table-cell centered",
        headerClasses: "consequences-table-header",
        expandable: true,
        rows: [ reputation1, reputation2, reputation3, reputation4, reputation5 ]
      },
      {
        dataField: datafield_prefix + "environmental",
        text: environment,
        classes: "consequences-table-cell centered",
        headerClasses: "consequences-table-header",
        expandable: true,
        rows: [ environment1, environment2, environment3, environment4, environment5 ]
      },
      {
        dataField: datafield_prefix + "legal",
        text: legal,
        classes: "consequences-table-cell centered",
        headerClasses: "consequences-table-header",
        expandable: true,
        rows: [ legal1, legal2, legal3, legal4, legal5 ]
      },
      {
        dataField: datafield_prefix + "community",
        text: community,
        classes: "consequences-table-cell centered",
        headerClasses: "consequences-table-header",
        expandable: true,
        rows: [ community1, community2, community3, community4, community5 ]
      },
    ]

  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      row: nextProps.row
    })
  }

  consequenceFormatter = (cell, column, expandable) => {
    return <ConsequenceCell {...{ column, expandable }}>{ cell }</ConsequenceCell>
  }

  getTargetValue = (rowIndex) => {
    return rowIndex + 1
  }

  getCellClass = (dataField, rowIndex, classes) => {
    const currentValue = this.state.row[dataField] ? this.state.row[dataField].toString() : '';
    const targetValue = this.getTargetValue(rowIndex).toString();
    if( currentValue === targetValue) return `${classes} selected`;
    return classes
  }

  tableColumns = () => {
    return this.consequences.map((consequence, i) => {
      const { dataField, text, classes, headerClasses, headerAttrs, hidden, expandable } = consequence;
      return { dataField, text, classes, headerClasses, headerAttrs, hidden, expandable }
    })
  }

  tableRows = () => {
    const { rowsCount } = this.state;
    let tableRows = [];

    for (var x = 0; x < rowsCount; x++) {
      const tableRow = {}
      for (const consequence of this.consequences) {
        const { dataField, rows } = consequence;
        tableRow[dataField] = rows[x];
      }
      tableRows.push(tableRow)
    }
    return tableRows
  }

  onClose = () => {
    this.props.onUpdate(this.state.row[this.props.column.dataField])
  }

  onCellClick = (e, row, rowIndex) => {
    if (!e.target.hasAttribute("column")) return;

    const column = e.target.getAttribute("column")
    
    if (this.state.notClickableColumns.includes(column)) return;

    const oldValue = this.props.row[column] ? this.props.row[column].toString() : '';
    let newValue = this.getTargetValue(rowIndex).toString();

    if (oldValue.length > 0 && oldValue === newValue) {
      newValue = ''
    }

    let { row: updatedRow } = this.state;
    updatedRow[column] = newValue;

    this.setState({ row: updatedRow });

    const consequence = this.tableColumns().find((consequence) => consequence.dataField === column);
    this.props.changeHandler(oldValue, newValue, updatedRow, consequence)
  }

  ConsequencesTable = () => {
    const tableColumns = this.tableColumns();
    const tableRows = this.tableRows();

    return (
      <div className="consequences-table-container">
        <table className="consequences-table">
          <thead>
            <tr>
              {
                tableColumns.map((column, i)=>{
                  const { text, headerClasses } = column;
                  return <th key={i} className={headerClasses}>{text}</th>
                })
              }
            </tr>
          </thead>
          <tbody>
            {
              tableRows.map((row, rowIndex)=>{
                return (
                  <tr key={rowIndex}>
                    {
                      tableColumns.map((column, colIndex)=>{
                        let { dataField, classes, hidden=false, expandable } = column;

                        if (hidden) return;
        
                        const text = row[dataField];
                        classes = this.getCellClass(dataField, rowIndex, classes);

                        return (
                          <td key={colIndex} className={classes} column={dataField} title={text} onClick={(e)=>this.onCellClick(e, row, rowIndex)}>
                            <ConsequenceCell {...{ column: dataField, expandable }}>{ text }</ConsequenceCell>
                          </td>
                        )
                      })
                    }
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>
    )
  }

  ConsequencesModal = (props) => {
    let { className } = props;
    className = className ? `consequences-modal ${className}` : 'consequences-modal'

    const { ConsequencesTable } = this;

    const title = this.props.isNewConsequence ? getText("Final Consequences Rating") : getText("Current Consequences Rating");

    return (
      <Modal className={className} size="large" open={true} onClose={this.onClose}>
        <Modal.Header className="consequences-header">
          <b className="consequences-header-title">{title}</b>
          <i className="delete icon consequences-header-close-button" onClick={ this.onClose }></i>
        </Modal.Header>
        <Modal.Content className="consequences-content">
          <ConsequencesTable />
        </Modal.Content>
      </Modal>
    )
  }

  render() {
    const { ConsequencesModal } = this;
    return <ConsequencesModal className="five-consequences-modal" />
  }
}



// WEBPACK FOOTER //
// ./src/views/consequences_tables/teck/five_consequences_table.js